import { TertiaryPackingRptService } from '../services';
import { TertiaryPackingRptConstants } from '../constants';
import {alertActions} from '.';

export const TertiaryPackingRptActions = {
    getAll,
    loadingData,
    exportData
};

function getAll(obj)
{
    return dispatch =>{
        dispatch(request());
        TertiaryPackingRptService.fetchTertiaryData(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))

            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(successExport(data))
        },
        error => {
            dispatch(failure(error.toString()));
            dispatch(alertActions.error(error.toString()));
        }
        
        );
    };
    function request() { return { type : TertiaryPackingRptConstants.GETALL_REQUEST } }
    function success(datas) { return { type: TertiaryPackingRptConstants.GETALL_SUCCESS, datas } }
    function successExport(datas) { return { type: TertiaryPackingRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: TertiaryPackingRptConstants.GETALL_FAILURE, error } }
}

function exportData(obj) {
    return dispatch => {
        dispatch(request());
        TertiaryPackingRptService.fetchTertiaryData(obj).then(response => {
            dispatch(loadingData(false));
            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(success(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            });
    };
    function request() { return { type: TertiaryPackingRptConstants.GETEXPORT_REQUEST } }
    function success(datas) { return { type: TertiaryPackingRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: TertiaryPackingRptConstants.GETEXPORT_FAILURE, error } }
}

function loadingData(isbool) {
    return {
        type: TertiaryPackingRptConstants.LOADING_REQUEST, isbool
    }
}
